import { supabase } from '../lib/supabase';
import { isVideoFile, mediaBucketFor } from './products';

// Uploads one Studio file (image or video) under `{folder}/{timestamp}-{name}` and returns the
// media item to store in `images[]`.
export async function uploadMedia(file, folder) {
  const path = `${folder}/${Date.now()}-${file.name.replace(/[^a-zA-Z0-9._-]/g, '_')}`;
  const bucket = mediaBucketFor(file);
  const { error } = await supabase.storage.from(bucket).upload(path, file, { upsert: true, contentType: file.type || undefined });
  if (error) throw new Error(`${file.name}: ${error.message}`);
  const { data: { publicUrl } } = supabase.storage.from(bucket).getPublicUrl(path);
  return { url: publicUrl, filename: file.name, ...(isVideoFile(file) ? { kind: 'video' } : {}) };
}
